module.exports = __webpack_public_path__ + "static/media/skype.119ba5ea.svg";